import { IconProps } from '../Icons.type'

export function QuestionIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}>
      <path
        fill="currentColor"
        d="M11.8 0C5.29 0 0 5.29 0 11.8s5.29 11.8 11.8 11.8 11.8-5.29 11.8-11.8S18.31 0 11.8 0m0 21.6c-5.4 0-9.8-4.4-9.8-9.8S6.4 2 11.8 2s9.8 4.4 9.8 9.8-4.4 9.8-9.8 9.8"></path>
      <path
        fill="currentColor"
        d="M14.05 5.49c-.56-.38-1.22-.62-1.89-.68-.68-.06-1.36.05-1.98.33s-1.17.71-1.57 1.26c-.33.44-.24 1.07.2 1.4s1.07.24 1.4-.2c.2-.27.48-.49.79-.63s.65-.2.99-.16c.34.03.67.15.95.34s.51.45.66.76c.15.3.22.65.21.98-.02.34-.12.67-.3.96s-.43.53-.73.7-.63.25-.97.25c-.55 0-1 .45-1 1s.45 1 1 1c.68 0 1.35-.18 1.95-.51.59-.33 1.1-.81 1.45-1.39.36-.58.56-1.24.59-1.93a4.03 4.03 0 0 0-1.74-3.49zM11.8 15.3a1.9 1.9 0 1 0 0 3.8 1.9 1.9 0 1 0 0-3.8"></path>
    </svg>
  )
}
